
import React, { Suspense, lazy, useRef, useState, useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import appstore1 from '../assets/web/images/app-store-1.png';
import appstore2 from '../assets/web/images/play-store-2.png';
import downloadminibg from '../assets/web/images/download-mini-bg.png';
const  Download = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
    <div class="ivo-text-box ivo-section text-center">
        <h2 class="ivo-heading">
            <span class="color_title">DOWNLOAD</span>  IVOIRE
        </h2>
        <p class="ivo-para">Ivoire is World,s Most trusted app for<br /> Comodity And Market.</p>
    </div>
    <section class="ivo-section ivo-download-box">
        <div class="container ivo-ovrflow-hidden">
           
            <div class="ivo-download-box-content ivo-ovrflow-hidden">
                <div class="ivo-download-text text-center animate__animated  wow animate__fadeInUp">
                    <h1>
                        DOWNLOAD IVOIRE
                    </h1>
                    <div class="mt-2">
                        <Link class="mr-2" href=""><img src={appstore1} alt="" /></Link>
                         <Link href="" > <img src={appstore2} alt=""  /></Link>
                    </div>
                </div>
                <div class="ivo-img-box animate__animated  wow animate__fadeInUp ">
                    <img class="img-fluid" src={downloadminibg} alt="" />
                </div>


            </div>
        </div>
    </section>
    </>

  );
}

export default Download;
